
import { DashboardPage } from "../../components/layout/dashboardPage";
import { Notifications } from "../../components/dashboard/notifications";
import { Col } from "../../style/base.style";
import { Colors } from "../../style/colors";
import { Family } from "../../components/dashboard/family";

export const DashboardFamily:React.FC = () => {

  
    return (
      <DashboardPage title="my_family">
        <Col $width="100%" $justifyContent="flex-start" $alignItems="flex-start" $backgroundColor={Colors.whiteBackground} $padding="20px" $border={`1px solid ${Colors.fieldBorder}`} $borderRadius={10}>
         <Family/>
        </Col>
        
          
      </DashboardPage>
        
    )
}